/* ============
 * All License Groups
 * ============
 *
 * All license groups.
 */

import Vue from 'vue';
import store from '../../store';
import licenseGroupTransformer from '../../transformers/licenseGroup';

const success = ({ data }, resolve) => {
  const licenseGroups = licenseGroupTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllLicenseGroups', licenseGroups);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display license groups.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('license/groups')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/licenseGroup/all.js